module.exports = __webpack_public_path__ + "img/shutterstock_1563129436.81e41e74.jpg";